import { ref } from 'vue';

export type ToastTone = 'success' | 'error' | 'info' | 'warning';

export type ToastItem = {
  id: number;
  title: string;
  messages: string[];
  tone: ToastTone;
};

const toasts = ref<ToastItem[]>([]);
let seq = 0;

export function useToast() {
  function push(title: string, tone: ToastTone = 'info', durationMs = 4000, messages: string[] = []): void {
    const id = ++seq;
    toasts.value.push({ id, title, messages, tone });
    window.setTimeout(() => {
      toasts.value = toasts.value.filter((t) => t.id !== id);
    }, durationMs);
  }

  function success(message: string): void {
    push('Success', 'success', 4000, [message]);
  }

  function error(title: string, messages: string[] = []): void {
    push(title, 'error', 6000, messages);
  }

  function warning(title: string, messages: string[] = []): void {
    push(title, 'warning', 6000, messages);
  }

  function dismiss(id: number): void {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return { toasts, push, success, error, warning, dismiss };
}
